import React from 'react';
import { prismaService } from '../../server/service/PrismaService';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { Store } from '../../pagepart/store/Store';
import { LehrerWelcomeAnonym } from '../../pagepart/lehrer/index/LehrerWelcomeAnonym';
import { LehrerDashboard } from '../../pagepart/lehrer/index/LehrerDashboard';
import { Env } from '../../env/Env';
import { ServerProps } from '../../pagepart/portal/utils';
import { LehrerPortal_ } from 'src/pagepart/lehrer/LehrerPortal_';

export async function getServerSideProps(rawContext) {
  const { env, lehrerEnv, requestEnv } = await Env.forNextContext(rawContext);
  const { post } = requestEnv;

  if (lehrerEnv.lehrer && post.neuerName) {
    lehrerEnv.lehrer = await prismaService.local.lehrer.update({
      data: {
        name: post.neuerName,
      },
      where: { id: lehrerEnv.lehrer.id },
    });
  }

  if (lehrerEnv.lehrer && rawContext.query.accept === '1') {
    lehrerEnv.lehrer = await prismaService.local.lehrer.update({
      data: {
        acceptAt: new Date(),
        acceptIp: rawContext.req.headers['x-real-ip'],
      },
      where: { id: lehrerEnv.lehrer.id },
    });
  }

  return {
    props: {
      ...env.transfer,
    },
  };
}

class App extends React.Component<ServerProps<typeof getServerSideProps>> {
  @memoize
  get store() {
    return Store.forApp(this);
  }

  setupPage(store: Store) {
    store.portalStore.metaTitle = 'Schlaukopf Lehrerbereich';
    store.portalStore.subheaderTitle = <span>Zugang zum Lehrerbereich</span>;
    store.portalStore.includeStylesheetOnce('/static/dist7/assets/css/pages/wizard/wizard-1.css');
  }

  render() {
    const { lehrer } = this.store.lehrerStore;

    if (lehrer) {
      return (
        <LehrerPortal_ store={this.store}>
          <LehrerDashboard />
        </LehrerPortal_>
      );
    }

    return (
      <LehrerPortal_ store={this.store}>
        <LehrerWelcomeAnonym />
      </LehrerPortal_>
    );
  }

  componentDidMount() {
    window.KTApp.initComponents();
  }

  /*
  validateForm = e => {
    if ($('#checkAgb').is(':checked')) {
    } else {
      window.swal.fire('Bitte akzeptieren Sie die Datenschutz- und Nutzungsbedingungen.');
      e.preventDefault();
      return false;
    }
  }; */
}

export default App;
